import React from 'react'

export const EmptyStubComponent: React.FC = () => null
